module.exports = __webpack_public_path__ + "static/media/homeIconWhite.281783ab.svg";